import { FilterIcon } from './filter-icon'
import { FilterItemButton } from './filter-item-button'
import { SidebarFilterSection } from './sidebar-filter-section'
import { useFilterContext } from '../../context/filter-context'
import { WorkoutEquipmentGroup } from '../../dao/core-dao'
import { useWorkoutEquipmentGroups } from '../../hook/use-workouts'
import React from 'react'

export const EquipmentFilter = (): React.ReactElement | null => {
  const { workoutFilter, toggleFilterEntry } = useFilterContext()
  const { data: availableEquipmentGroups = [] } = useWorkoutEquipmentGroups()

  if (!availableEquipmentGroups || availableEquipmentGroups.length === 0) {
    return null
  }

  const handleToggleSelectedEquipment = ({ name }: WorkoutEquipmentGroup): void => {
    toggleFilterEntry('equipment', name)
  }

  const renderEquipment = (equipment: WorkoutEquipmentGroup, additionalClass?: string): React.ReactElement => {
    const isActive = workoutFilter?.equipment?.includes(equipment.name) ?? false
    return (
      <FilterItemButton
        className={additionalClass}
        onClick={() => handleToggleSelectedEquipment(equipment)}
        isActive={isActive}
        fullWidth={true}
      >
        <FilterIcon height={27} filterEntry={equipment} active={isActive} />
        <span className="font-roboto-condensed font-semibold text-xs leading-4 text-ivory">{equipment.label}</span>
      </FilterItemButton>
    )
  }

  return <SidebarFilterSection title={`Equipment`} items={availableEquipmentGroups} lineLimit={4} renderItem={renderEquipment} />
}
